
























































































































































































































































































































































































import { ValidationObserver } from 'vee-validate';
import Vue from 'vue';
import { debounce, isObject } from 'lodash';

import { getPlansData } from '@/web/utils/plans';
import PlanCard from '@/web/components/signup/PlanCard.vue';
import { mapGetters } from 'vuex';
import auth from '@/core/api/modules/auth';
import { style } from '@/web/utils/stripe';
import { trackPurchase, register, track } from '@/web/services/analytics';
import { errorToMessage, scrollToFirstFormError } from '@/core/utils/errors';
import { loadDeadlineFunnelScript } from '@/web/utils/deadlinefunnel';
import timezones from '@/web/utils/timezones.ts';
import { getConfig } from '@/web/utils/configuration';
import StudentLogin from '@/web/components/signup/StudentLogin.vue';
import { sanitize } from '@/core/utils/utils';
import { getTrackingParams } from '@/web/utils/tracking';

export default Vue.extend({
  components: { PlanCard, ValidationObserver },
  data() {
    return {
      subscriptionType: 'yearly',
      allPlansInclude: [
        'SIGNUP.TEXT.LIVE_STREAMING',
        'SIGNUP.TEXT.SET_YOUR_PRICING',
        'SIGNUP.TEXT.OFFER_COACHING',
        'SIGNUP.TEXT.NO_REV_SHARE',
        'SIGNUP.TEXT.SELL_COURSES',
        'SIGNUP.TEXT.INSTANT_PAYOUTS',
      ],
      selectedPlanId: null,
      teacherForm: {
        yoga_alliance_membership_id: '',
        studio_name: '',
        first_name: '',
        last_name: '',
        email: '',
        password: '',
        password_repeat: '',
      },
      usingCoupon: false,
      showCoupon: false,
      freeTrial: false,
      coupon: null,
      couponError: null,
      inProgress: false,
      stripeCompleted: false,
      stripeError: false,
      emailInfo: null,
      URLInfo: null,
      timezone: null,
      timezones,
      campaigns: {
        yogaalliance: {
          logo: '/assets/images/yoga-alliance.png',
          defaultSubscriptionType: 'yearly',
        },
        lululemon: {
          logo: '/assets/images/lululemon.png',
          brandColor: '#C8102E',
          defaultSubscriptionType: 'yearly',
        },
        yap: {
          logo: '/assets/images/yap.png',
          brandColor: '#3EBBC0',
          reversePlans: true,
          defaultSubscriptionType: 'monthly',
          embeddedAffiliate: true,
        },
        vstudio: {
          logo: '/assets/images/vstudio.png',
          logoHeight: 100,
          brandColor: '#447e69',
          reversePlans: true,
          defaultSubscriptionType: 'monthly',
          embeddedAffiliate: true,
        },
      },
      isUsedEmail: false,
    };
  },
  props: {
    campaign: {
      type: String,
      default: null,
    },
    sale: {
      type: Boolean,
      default: false,
    },
    affiliateRef: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters('user', [
      'userId',
      'studentId',
      'teacher',
      'userPlans',
      'couponDuration',
      'isLoggedIn',
      'hasSubscriptionType',
      'hasMultiPlans',
    ]),
    ...mapGetters({
      affiliateCode: 'globals/affiliateCode',
      affiliateCoupon: 'affiliates/affiliateCoupon',
    }),
    plansData() {
      return [...(this.userPlans || [])]
        .filter(plan => !(plan.hide_for_affiliates && this.affiliateCode))
        .sort((planA, planB) =>
          this.campaignData?.reversePlans
            ? planA.tier - planB.tier
            : planB.tier - planA.tier
        )
        .map(plan =>
          getPlansData(
            plan,
            this.subscriptionType,
            this.selectedPlanId,
            this.freeTrial,
            7,
            this.subscriptionType,
            this.couponDuration
          )
        );
    },
    selectedPlan() {
      return this.plansData?.find(plan => plan.id === this.selectedPlanId);
    },
    isDiscounted() {
      return this.selectedPlan?.discounted;
    },
    isDiscountedForever() {
      return this.couponDuration?.duration === 'forever';
    },
    isDiscountedOnce() {
      if (this.isDiscountedMonths && this.discountedMonthsNum) return true;

      return this.couponDuration?.duration === 'once';
    },
    isDiscountedMonths() {
      return this.couponDuration?.duration === 'repeating';
    },
    discountedMonthsNum(): number {
      return this.couponDuration?.duration_in_months || 0;
    },
    discountedText() {
      if (!this.isDiscounted) return '';
      if (this.isDiscountedForever) return '';
      let months = 1;
      if (this.isDiscountedMonths) {
        months = this.discountedMonthsNum as number;
      }
      const discountedPrice = this.selectedPlan.amount;
      const standardPrice = this.selectedPlan.standard;
      const paymentInterval =
        this.subscriptionType === 'monthly' ? 'mo' : 'year';
      if (this.subscriptionType === 'monthly') {
        if (discountedPrice === 0) {
          return this.$tc('SIGNUP.TEXT.MONTHLY_TOTAL_CHECKOUT_FREE', months, {
            discountedPrice,
            months,
            paymentInterval,
            standardPrice,
          });
        }
        return this.$tc('SIGNUP.TEXT.MONTHLY_TOTAL_CHECKOUT', months, {
          discountedPrice,
          months,
          paymentInterval,
          standardPrice,
        });
      } else {
        const years = Math.ceil(months / 12);
        if (discountedPrice === 0) {
          return this.$tc('SIGNUP.TEXT.ANNUAL_TOTAL_CHECKOUT_FREE', years, {
            discountedPrice,
            years,
            paymentInterval,
            standardPrice,
          });
        }
        return this.$tc('SIGNUP.TEXT.ANNUAL_TOTAL_CHECKOUT', years, {
          discountedPrice,
          years,
          paymentInterval,
          standardPrice,
        });
      }
    },
    campaignData() {
      return this.campaigns[this.campaign];
    },
    plansCampaign() {
      return this.campaignData?.plansCampaign || this.campaign;
    },
    config() {
      return getConfig();
    },
    applicationName() {
      return this.config.applicationName;
    },
    isNamastreamDomain() {
      return window.location.host.toLowerCase().indexOf('namastream') !== -1;
    },
    affiliateDiscount() {
      const coupon = this.affiliateCoupon;
      if (!coupon) return null;

      let duration = '';
      if (coupon.duration === 'forever') {
        duration = ` ${this.$t(
          'SIGNUP.TEXT.AFFILIATE_COUPON_DURATION_FOREVER'
        )}`;
      } else if (coupon.duration === 'repeating') {
        duration = ` ${this.$tc(
          'SIGNUP.TEXT.AFFILIATE_COUPON_DURATION_REPEATING_VARIANT',
          coupon.duration_in_months,
          { duration: coupon.duration_in_months }
        )}`;
      }

      if (coupon.amount_off) return `$${coupon.amount_off}${duration}`;
      if (coupon.percent_off) return `${coupon.percent_off}%${duration}`;

      return null;
    },
    getAffiliateDiscountedPrice() {
      const coupon = this.affiliateCoupon;
      if (!coupon) return null;
      const plan = this.selectedPlan;

      return Math.round(Math.max(plan.amount, 0));
      // let discountedPrice = plan.amount;
      // if (coupon.amount_off) {
      //   discountedPrice = Math.max(plan.amount - coupon.amount_off, 0);
      // }
      // if (coupon.percent_off) {
      //   discountedPrice =
      //     Math.round(100 * plan.amount * ((100 - coupon.percent_off) / 100.0)) /
      //     100;
      // }

      // return discountedPrice;
    },
    getSelectedPlanAffiliateDiscountCheckoutSummaryText() {
      const coupon = this.affiliateCoupon;
      if (!coupon) return null;
      const plan = this.selectedPlan;

      const discountedPrice = this.getAffiliateDiscountedPrice;

      if (coupon.duration === 'once') {
        return this.$t('SIGNUP.TEXT.AFFILIATE_COUPON_INITIAL_PAYMENT', {
          discountedPrice,
          originalAmount: plan.fullAmountText,
        });
      } else if (coupon.duration === 'forever') {
        // forever coupons are applied for all plans forever and don't need
        // any special text on how long the discount is valid
        return null;
      } else if (coupon.duration === 'repeating') {
        return this.$tc(
          'SIGNUP.TEXT.AFFILIATE_COUPON_DURATION_REPEATING_THEN_ORIGINAL_AMOUNT_VARIANT',
          coupon.duration_in_months,
          {
            duration: coupon.duration_in_months,
            discountedPrice,
            originalAmount: plan.fullAmountText,
          }
        );
      }

      return null;
    },
    getCheckoutFullAmountText() {
      if (this.getAffiliateDiscountedPrice) {
        return this.$t(this.selectedPlan.amountKey, {
          amount: this.getAffiliateDiscountedPrice,
        });
      }

      return this.selectedPlan.fullAmountText;
    },
  },
  methods: {
    sanitize,
    openLoginModal() {
      this.$modal.show(StudentLogin, {});
    },
    selectPlan(planId) {
      this.selectedPlanId = planId;
      const { id, name } = this.selectedPlan || {};
      this.$trackOnPage('teacher switched signup plan', {
        plan_id: id,
        plan_name: name,
      });
    },
    setSubscriptionType(type) {
      this.subscriptionType = type;
      this.$trackOnPage('teacher switched signup type', { type });
    },
    removeCoupon() {
      this.$store.dispatch('user/clearCoupon');
    },
    async validateStudioName() {
      // can't validate studio url without auth headers of an existing account... how to do this?
      console.log('validation needed');
    },
    async applyCoupon() {
      try {
        const coupon = this.coupon;
        const campaign = this.plansCampaign;
        await this.$store.dispatch('user/applyCoupon', { coupon, campaign });
        this.couponError = null;
        this.usingCoupon = true;
      } catch (error) {
        this.couponError = error.response.data?.message;
        this.usingCoupon = false;
      }
    },
    stripeChangeCallback(event) {
      if (event.complete) {
        this.stripeCompleted = true;
        this.stripeError = false;
      } else if (event.error) {
        this.stripeCompleted = false;
        this.stripeError = event.error.message;
      }
    },
    initStripe() {
      this.stripe = window.Stripe(process.env.VUE_APP_STRIPE_PUBLIC);
      const elements = this.stripe.elements();
      this.card = elements.create('card', {
        style,
        hidePostalCode: true,
      });
      const interval = setInterval(
        () => {
          if (this.$refs['card-element']) {
            this.card.mount(this.$refs['card-element']);
            this.card.addEventListener('change', this.stripeChangeCallback);
            clearInterval(interval);
          }
        },
        50,
        100
      );
    },

    async signup() {
      this.$refs.form.validate();
      const invalid = this.$refs.form?.flags?.invalid;
      if (invalid) {
        setTimeout(() => {
          scrollToFirstFormError();
        });
      }

      if (
        !this.stripeCompleted ||
        !this.timezone ||
        invalid ||
        this.inProgress
      ) {
        return;
      }

      const reCaptchaKey = process.env.VUE_APP_RECAPTCHA_KEY;
      let reCaptchaToken;
      try {
        reCaptchaToken = await window.grecaptcha.execute(reCaptchaKey, {
          action: 'teachersetupintent',
        });
      } catch (error) {
        this.inProgress = false;
        this.$notify({
          group: 'app',
          type: 'error',
          text: this.$t('GENERAL.ERROR.RECAPTCHA_FAILED'),
        });
      }

      this.inProgress = true;
      const data = {
        ...this.teacherForm,
        ...getTrackingParams(),
        coupon: this.coupon || this.affiliateCoupon?.discount_coupon_code,
        campaign: this.plansCampaign,
        plan_id: this.selectedPlanId,
        subscription_type: this.subscriptionType,
        password1: this.teacherForm.password_repeat,
        timezone: this.timezone.value,
        free_trial: this.freeTrial,
        token: reCaptchaToken,
      };

      if (this.campaign !== 'yogaalliance')
        delete data.yoga_alliance_membership_id;

      try {
        const setupIntent = await auth.getSetupIntent(data);
        data.stripe_customer_id = setupIntent.stripe_customer_id;
        data.setup_intent_id = setupIntent.setup_intent.id;

        const confirmCard = await this.stripe.confirmCardSetup(
          setupIntent.setup_intent.client_secret,
          { payment_method: { card: this.card } }
        );

        data.default_payment_method = confirmCard.setupIntent.payment_method;

        data.affiliate_ref = this.affiliateCode;

        reCaptchaToken = await window.grecaptcha.execute(reCaptchaKey, {
          action: 'teachersignup',
        });
        data.token = reCaptchaToken;

        if (this.isLoggedIn) await auth.promoteStudentToTeacher(data);
        else await auth.registerTeacher(data);

        const selectedPlan = this.userPlans.find(
          plan => plan.id == this.selectedPlanId
        );

        const planAmount = selectedPlan[`${this.subscriptionType}_amount`];

        if (!this.isLoggedIn) await this.$store.dispatch('user/login', data);

        await this.$store.dispatch('user/loadUserInfo');

        const registerData = {
          first_name: this.teacher?.first_name,
          last_name: this.teacher?.last_name,
          email: this.teacher?.email,
          user_id: this.userId,
          student_id: this.studentId,
          studio_url: this.teacher?.studio_url,
          studio_name: this.teacher?.studio_name,
        };

        const traitsData = {
          coupon: this.coupon || this.affiliateCoupon?.discount_coupon_code,
          affiliate_ref: this.affiliateCoupon?.ref,
          campaign: this.plansCampaign,
          plan_id: this.selectedPlanId,
          plan_name: this.selectedPlan.plan_name,
          plan_amount: planAmount,
          subscription_type: this.subscriptionType,
          studio_name: this.teacher?.studio_name,
        };

        register(this.userId, registerData);
        this.$trackOnPage('teacher signed up', {
          ...registerData,
          ...traitsData,
        });
        trackPurchase(traitsData);

        const query = {};
        if (this.freeTrial) query.trial = true;

        this.$router.push({
          name: 'thank-you',
          query,
        });
      } catch (error) {
        console.error(error);
        const errorMessage = errorToMessage(error.response);
        if (isObject(errorMessage)) {
          this.$refs.form.setErrors(errorMessage);
          scrollToFirstFormError();
        } else {
          this.$notify({
            group: 'app',
            type: 'error',
            text: errorMessage || error,
            duration: -1, // stay ON
          });
        }
        this.inProgress = false;
      }
    },
    loadScripts() {
      loadDeadlineFunnelScript();
    },
    setLocalTimeZone() {
      try {
        const localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const timezone = this.timezones.find(
          ({ value }) => value === localTimeZone
        );
        if (timezone) this.timezone = timezone;
      } catch (error) {
        console.error(error);
      }
    },
    setBrandColor(color) {
      const html = document.querySelector('html');
      html.style.setProperty('--brand-color', color);
    },
    async redirectIfTeacher() {
      await this.$store.state.user.userInfoPromise;
      if (this.teacher) {
        this.$router.replace({ name: 'settings-adjust-plan' });
      }
    },
  },
  watch: {
    'teacherForm.email': debounce(async function () {
      if (this.$refs.form.fields?.email.valid) {
        try {
          await auth.verifyEmail(this.teacherForm.email);
          this.emailInfo = null;
        } catch (error) {
          this.emailInfo = this.$t('GENERAL.ERROR.ARE_YOU_SURE_THIS_EMAIL');
        }
      } else {
        this.emailInfo = null;
      }

      if (this.$refs.form.fields?.email.valid) {
        try {
          await auth.verifyNewEmail(this.teacherForm.email);
          this.isUsedEmail = false;
        } catch (error) {
          this.isUsedEmail = true;
        }
      } else {
        this.isUsedEmail = false;
      }
    }, 400),
    affiliateCoupon: {
      handler(affiliateCoupon) {
        if (affiliateCoupon && affiliateCoupon.duration === 'forever') {
          this.coupon = this.affiliateCoupon.discount_coupon_code;
          this.applyCoupon();
        }
      },
      immediate: true,
    },
  },
  async mounted() {
    this.redirectIfTeacher();
    this.freeTrial = 'free-trial' in this.$route.query;
    this.showCoupon = 'enable-coupon' in this.$route.query;
    if (this.isNamastreamDomain && process.env.NODE_ENV === 'production') {
      window.location.hostname = 'app.heymarvelous.com';
    }
    if (this.campaignData?.embeddedAffiliate) {
      this.$store.dispatch('globals/setAffiliateCode', this.affiliateRef);
      this.$store.dispatch('affiliates/setAffiliateCoupon', null);
      this.freeTrial = true;
      this.showCoupon = false;
      this.subscriptionType = this.campaignData.defaultSubscriptionType;
      if (this.affiliateRef) {
        const affiliateDiscount = await this.$store.dispatch(
          'affiliates/trackAffiliateLinkClick',
          {
            code: this.affiliateRef,
            valid: true,
          }
        );
        this.$store.dispatch(
          'affiliates/setAffiliateCoupon',
          affiliateDiscount
        );
      }
    }
    this.campaign = this.campaign || getConfig().signupCampaign;
    this.initStripe();
    this.loadScripts();
    this.removeCoupon();
    await this.$store.dispatch('user/getPlans', this.plansCampaign);
    const selectedPlan =
      this.userPlans.find(plan => plan.is_default) || this.userPlans[0];
    this.selectedPlanId = selectedPlan?.id;
    this.setLocalTimeZone();
    if (this.campaignData?.brandColor) {
      this.setBrandColor(this.campaignData.brandColor);
    }
  },
  destroyed() {
    this.removeCoupon();
    this.setBrandColor(null);
  },
});
